export default "https://cdn-static.gokick.com/assets/faf4ec4796b5499b7477edf17656e3681d9dd642/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";